import { DATA_POINTS, TYPES } from './constants';

export const buildBrand = (brand = {}) => {
  if (!brand?.name) return undefined;

  return {
    '@type': TYPES.brand,
    '@id': brand.id,
    name: brand.name,
    alternateName: brand.alternateName,
    description: brand.description,
    url: brand.url,
    slogan: brand.slogan,
    sameAs: brand.sameAs,
    logo: brand.logo ? {
      '@type': TYPES.image_object,
      url: brand.logo.url || brand.logo,
      contentUrl: brand.logo.url || brand.logo,
      width: brand.logo.width || DATA_POINTS.image.schemaLogoWidth,
      height: brand.logo.height || DATA_POINTS.image.schemaLogoHeight,
      caption: brand.name,
    } : undefined,
    image: brand.image ? {
      '@type': TYPES.image_object,
      url: brand.image.url || brand.image,
      contentUrl: brand.image.url || brand.image,
      width: brand.image.width || 1200,
      height: brand.image.height || 630,
      caption: brand.name,
    } : undefined,
    aggregateRating: brand.rating?.average && brand.rating?.ratingCount ? {
      '@type': TYPES.aggregate_rating,
      ratingValue: brand.rating.average,
      ratingCount: brand.rating.ratingCount,
      reviewCount: brand.rating.reviewCount || brand.rating.ratingCount,
      bestRating: Number(brand.rating.bestRating || DATA_POINTS.aggregateRating.bestRating),
      worstRating: Number(brand.rating.worstRating || DATA_POINTS.aggregateRating.worstRating),
    } : undefined,
  };
};

export const buildOwnBrand = (options = {}) => buildBrand({
  id: `${DATA_POINTS.url.base}/#brand`,
  name: options.name || DATA_POINTS.name,
  ...options,
});

export const buildBrandFromProduct = () => ({
  '@type': TYPES.brand,
  '@id': `${DATA_POINTS.url.base}/#brand`,
  name: DATA_POINTS.name,
});

